import get from 'lodash/get';
import { FieldTemplateProps } from '@rjsf/utils';

const FieldTemplate = (props: FieldTemplateProps) => {
  const { id, classNames, label, help, required, description, errors, children, uiSchema } = props;

  const showLabel = (label || required) && id !== 'root' && get(uiSchema, ['ui:options', 'label']) !== false;

  return (
    <div className={classNames}>
      {showLabel && <label htmlFor={id}>{label}</label>}
      {description}
      {children}
      {errors}
      {help}
    </div>
  );
};

// eslint-disable-next-line import/no-default-export
export default FieldTemplate;
